import { useApi } from "./useApi";

export interface Persona {
  key: string;
  name: string;
  tag: string;
  ttsVoice: string;
  description: string;
  enabled: boolean;
  seq: number;
}

// Legacy fallback — concise=小船长(Momo) / story=金梅导游(Cherry) / talky=鲟侠船长(Ethan)。
// 顺序与 variant 顺序对齐(简约→故事→话痨)。
const FALLBACK_PERSONAS: Persona[] = [
  { key: "xiaoship", name: "小船长",   tag: "公务版", ttsVoice: "Momo",   description: "", enabled: true, seq: 1 },
  { key: "jinmei",   name: "金梅导游", tag: "故事版", ttsVoice: "Cherry", description: "", enabled: true, seq: 2 },
  { key: "xunxia",   name: "鲟侠船长", tag: "话痨版", ttsVoice: "Ethan",  description: "", enabled: true, seq: 3 },
];

// usePersonas pulls the live persona/voice config from /personas-config so that
// every voice picker in the admin reflects the actual configured set (new
// personas like 江豚仔/话痨版 show up automatically, removed ones disappear).
export function usePersonas(): { personas: Persona[]; names: string[] } {
  const { data } = useApi<Persona[]>("/personas-config", FALLBACK_PERSONAS);
  const enabled = (data || [])
    .filter((p) => p && p.enabled !== false && (p.name || "").trim() !== "")
    .sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0));
  return { personas: enabled, names: enabled.map((p) => p.name) };
}
